module.exports = __webpack_public_path__ + "media/images/past_order_history/btn_Order_2_02-7c38bd025c9d9ccb5cbd263d51788307.png";